import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App.jsx';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
    },
  },
});

createRoot(document.getElementById('root')).render(
  <StrictMode>
    {/* vista#792: opt into the v7 behaviours now. Both flags were emitting
    console warnings on every page load, which is noise an operator
    reporting a real console error has to read past — and opting in early
    means the eventual v7 upgrade is not also a behaviour change.
    `v7_startTransition` wraps router state updates in
    `React.startTransition`; `v7_relativeSplatPath` fixes relative route
    resolution inside splat routes, which the in-shell NotFound catch-all
    (§10.1) sits under. */}
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </BrowserRouter>
  </StrictMode>,
);
